var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGreatIcon = function SvgGreatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5654",
    width: 29,
    height: 29.253
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 368",
    cx: 14.374,
    cy: 14.626,
    rx: 14.374,
    ry: 14.626,
    transform: "translate(.252)",
    fill: "#fdd402"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3835",
    d: "M3.964 14.5A14.5 14.5 0 0116.482.135a14.5 14.5 0 100 28.729A14.5 14.5 0 013.964 14.5z",
    fill: "#fbbf13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3836",
    d: "M20.396 19.552a.331.331 0 01.463.333 6.205 6.205 0 01-6.184 5.647h-.348a6.2 6.2 0 01-6.184-5.647.331.331 0 01.463-.333 14.469 14.469 0 005.9 1.261h.074a14.464 14.464 0 005.816-1.261z",
    fill: "#74563a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3837",
    d: "M13.813 25.009a6.192 6.192 0 01-3.656-4.869 14.486 14.486 0 01-1.546-.587.331.331 0 00-.464.333 6.2 6.2 0 006.184 5.647h.348a6.272 6.272 0 00.818-.053 6.16 6.16 0 01-1.684-.471z",
    fill: "#674b34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3838",
    d: "M17.173 25.008a6.183 6.183 0 01-2.5.524h-.345a6.186 6.186 0 01-2.5-.524 3.22 3.22 0 015.347 0zM7.704 7.767a.217.217 0 01-.261.162 2.581 2.581 0 00-3.1 1.929 2.581 2.581 0 001.929 3.1l.212.049 4.255.99a.793.793 0 00.952-.592l.99-4.255.049-.212a2.581 2.581 0 00-1.929-3.1 2.581 2.581 0 00-3.097 1.929zm13.873 0a.217.217 0 00.261.162 2.581 2.581 0 013.1 1.929 2.581 2.581 0 01-1.929 3.1l-.212.049-4.255.99a.793.793 0 01-.952-.592L16.6 9.15l-.049-.212a2.581 2.581 0 011.929-3.1 2.581 2.581 0 013.097 1.929z",
    fill: "#e5303e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3839",
    d: "M16.599 9.148l.059.252a2.578 2.578 0 011.821-1.58 2.581 2.581 0 013.1 1.929.217.217 0 00.261.162 2.581 2.581 0 012.967 1.522 2.568 2.568 0 00.131-1.575 2.581 2.581 0 00-3.1-1.929.217.217 0 01-.261-.162 2.581 2.581 0 00-3.1-1.929 2.581 2.581 0 00-1.929 3.1zM5.666 11.179a2.581 2.581 0 013.1-1.929.217.217 0 00.261-.162 2.581 2.581 0 013.1-1.929 2.592 2.592 0 01.456.152 2.577 2.577 0 00-1.777-1.473 2.581 2.581 0 00-3.1 1.929.217.217 0 01-.261.162 2.581 2.581 0 00-3.1 1.929 2.581 2.581 0 001.473 2.946 2.569 2.569 0 01-.152-1.625zm9.825 14.3l-.126.015-.063.007-.132.012-.164.011-.124.005H14.323a6.184 6.184 0 01-2.5-.524 3.439 3.439 0 01.721-.744 6.17 6.17 0 002.947 1.217z",
    fill: "#b72732"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3840",
    d: "M15.491 25.479l-.126.015-.063.007-.132.012-.164.011-.124.005H14.329a6.185 6.185 0 01-2.5-.524 3.437 3.437 0 01.721-.745 6.17 6.17 0 002.941 1.219z",
    fill: "#b72732"
  })));
};
export default SvgGreatIcon;